import gridFilter from "../util/gridFilter";

export default {
  init() {
    // JavaScript to be fired on the home page
    gridFilter(0);

    $(".grid--filter--toggle").on("click", () => {
      $(".grid--filter").toggleClass("open");
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/tripCalendar.js